export default __webpack_public_path__ + "static/img05-9b5a3dd7dd21b5f07dd62a1322a0c0e9.webp";